<script setup>
import { Avatar, Icon } from '@aryeo/runway'
import { Menu, MenuButton, MenuItems } from '@headlessui/vue'
import { BellIcon, UserCircleIcon, LogoutIcon } from '@heroicons/vue/solid'

import { useAuth } from '@/Hooks/Customer/useAuth'

import CsrfToken from '@/Components/Shared/CsrfToken.vue'
import UserMenuItem from '@/Components/Shared/Header/UserMenuItem.vue'

defineProps({
  isHeaderLight: {
    type: Boolean,
    default: true,
  },
})

const { authCustomerUser, authCustomerOrganization } = useAuth()
</script>

<template>
  <Menu as="div" class="relative inline-block my-auto text-left">
    <div>
      <MenuButton
        class="flex items-center justify-center h-10 px-3 text-sm focus:outline-none focus-visible:shadow-focus rounded-xl"
      >
        <div class="flex items-center gap-3">
          <Avatar
            :firstName="authCustomerUser.first_name"
            :lastName="authCustomerUser.last_name"
            :image="authCustomerUser.avatar_url"
            size="small"
          />
          <span
            class="block text-sm font-medium truncate"
            :class="isHeaderLight ? 'text-black' : 'text-white'"
            ><span class="sr-only">Open user menu for </span>{{ authCustomerUser.first_name }}
            {{ authCustomerUser.last_name }}</span
          >

          <Icon
            name="chevronDown"
            size="medium"
            :class="isHeaderLight ? 'text-black' : 'text-white'"
          />
        </div>
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <MenuItems
        class="absolute right-0 z-30 w-56 mt-1 origin-top-right bg-white rounded-xl shadow-card border p-2"
      >
        <div class="py-1">
          <UserMenuItem :href="route('web.customer.auth-customer-user.show')">
            <UserCircleIcon class="w-5 h-5 mr-3" aria-hidden="true" />
            Edit User
          </UserMenuItem>
          <UserMenuItem
            v-if="authCustomerOrganization.is_pro_account"
            :href="route('web.customer.notifications.preferences.edit')"
            class="whitespace-nowrap"
          >
            <BellIcon class="w-5 h-5 mr-3 shrink-0" aria-hidden="true" />
            Notification Preferences
          </UserMenuItem>
          <form method="post" :action="route('web.customer.login.destroy')">
            <CsrfToken />
            <UserMenuItem as="button" type="submit">
              <LogoutIcon class="w-5 h-5 mr-3" aria-hidden="true" />
              Logout
            </UserMenuItem>
          </form>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>
